import { ITableField } from '../../../../../../shared/Tables/Table'
import { IMaintenanceProcess } from '../../../maintenance.types.ts'
import EquipmentModelsTags from '../../../../../Equipment/pages/EquipmentModels/components/EquipmentModelsTags'
import MaintenanceProcessPeriodsTags from '../MaintenanceProcessPeriodsTags'

const maintenanceProcessesTableFields: ITableField<IMaintenanceProcess, keyof IMaintenanceProcess>[] = [
  {
    key: 'name',
    clientSideOrdering: true,
    width: '300px',
    header: 'Наименование модели',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
  {
    key: 'rules',
    clientSideOrdering: true,
    width: '300px',
    header: 'Периодичность',
    getter: (it) => <MaintenanceProcessPeriodsTags periods={it.rules.map((r) => r.period)} />,
    sortGetter: (it) => it.name,
  },
  {
    key: 'equipmentModels',
    clientSideOrdering: true,
    width: '600px',
    header: 'Модели лифтов',
    getter: (it) => <EquipmentModelsTags ids={it.equipmentModels} />,
    sortGetter: (it) => it.name,
  },
]

export default maintenanceProcessesTableFields
